
var insertCss = require('insert-css');
var ClassList = require("class-list");
var EventEmitter = require('events').EventEmitter;
var colors = require('./colors');

var Pairs = require('lodash.pairs');
var Filter = require('lodash.filter');
var SortBy = require('lodash.sortby');
var ForEach = require('lodash.foreach');
var Template = require('lodash.template');
var MapValues = require('lodash.mapvalues');
var Reduce = require('lodash.reduce');
var IsElement = require('lodash.iselement');
var Extend = require('lodash.assign');

var _menuTemplate = null;
var _cssTemplate = null;
var _levelTemplate = null;


var sortAndFilterManifests = function( manifests ) {
	
	var pairs = Pairs( manifests )
	
	var visible = Filter( pairs, function(keypair) {
		return keypair[1].visible !== false;
	})
	
	var sorted = SortBy( visible, function( keypair ) {
		return keypair[1].order;
	})
	
	return sorted;
};

var handlers = (function() {
	
	var bodyClass = ClassList( document.body );
	var isOpen = false;
	var emitter = null;
	var preventDefault = false;
	
	var toggle = function( e ) {
		if( e ) e.preventDefault();
		isOpen ? close() : open();
	};
	
	var close = function() {
		bodyClass.remove('poem-menu-open');
		emitter.emit('close');
		isOpen = false;
	};
	
	var open = function() {
		bodyClass.add('poem-menu-open');
		emitter.emit('open');
		isOpen = true;
	};
	
	var loadLevel = function( e ) {
		emitter.emit('load', {
			slug : this.getAttribute('data-slug')
		});
		close();
	};
	
	return function( config, currentEmitter, div ) {

		emitter = currentEmitter;
		preventDefault = config.preventDefault;
		
		var button = div.getElementsByClassName('poem-menu-burger')[0];
		button.addEventListener( 'click', toggle, false );
		
		var levelLinks = div
			.getElementsByClassName('poem-menu-levels')[0]
			.getElementsByTagName('a');
		
		ForEach( levelLinks, function( el ) {
			el.addEventListener( 'click', loadLevel, false );
		});
		
		div	.getElementsByClassName('poem-menu-blocker')[0]
			.addEventListener( 'click', close, false );
		
		window.addEventListener('keydown', function toggleMenuHandler( e ) {
			if( e.keyCode !== config.toggleKey ) return;
			toggle(e);
		});
		
		return {
			close : close,
			open : open
		};
	};
	
})();

var loadTemplatesOnce = (function() {
	
	var firstRun = true;
	
	return function() {
		
		if( firstRun ) {
			
			firstRun = false;
			
			_menuTemplate = Template(
				Buffer("PGRpdiBjbGFzcz0ncG9lbS1tZW51Jz4KCQoJPGEgY2xhc3M9InBvZW0tbWVudS1idXJnZXIiIGhyZWY9IiNtZW51IiB0aXRsZT0nSGl0IEVTQyBrZXkgdG8gb3Blbi9jbG9zZSc+CgkJPGRpdiBjbGFzcz0icG9lbS1tZW51LWJ1cmdlci1iYXJzIj48L2Rpdj4KCTwvYT4KCQoJPGRpdiBjbGFzcz0ncG9lbS1tZW51LXRvcCc+PC9kaXY+CgkKCTxkaXYgY2xhc3M9J3BvZW0tbWVudS1taWRkbGUnPgoJCTxkaXYgY2xhc3M9J3BvZW0tbWVudS1sZXZlbHMtdG9wJz48L2Rpdj4KCQk8ZGl2IGNsYXNzPSdwb2VtLW1lbnUtbGV2ZWxzJz4KCQkJPCU9IGxldmVscyAlPgoJCTwvZGl2PgoJCTxkaXYgY2xhc3M9J3BvZW0tbWVudS1sZXZlbHMtYm90dG9tJz48L2Rpdj4KCTwvZGl2PgoJCQoJPGRpdiBjbGFzcz0ncG9lbS1tZW51LWJvdHRvbSc+PC9kaXY+CgkKPC9kaXY+CjxkaXYgY2xhc3M9J3BvZW0tbWVudS1ibG9ja2VyJz48L2Rpdj4=","base64")
			);
			
			_levelTemplate = Template(
				Buffer("PGEgaHJlZj0nIy88JS0gc2x1ZyAlPicgZGF0YS1zbHVnPSc8JS0gc2x1ZyAlPicgY2xhc3M9J3BvZW0tbWVudS1sZXZlbCc+Cgk8aDIgY2xhc3M9J3BvZW0tbWVudS1sZXZlbC1uYW1lJz48JS0gbWFuaWZlc3QubmFtZSAlPjwvaDE+Cgk8ZGl2IGNsYXNzPSdwb2VtLW1lbnUtbGV2ZWwtZGVzY3JpcHRpb24nPjwlLSBtYW5pZmVzdC5kZXNjcmlwdGlvbiAlPjwvZGl2Pgo8L2E+","base64")
			);
			
			_cssTemplate = Template(
				Buffer("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","base64")
			);
			
		}
	};
	
})();

var runCssTemplates = function( config ) {
	
	var direction = config.primaryColor > config.menuColor ? 1 : -1;
	
	var css = _cssTemplate(MapValues({
		
		hamburger		: config.hamburgerColor,
		primaryActive	: config.primaryColor,
		text			: config.textColor,
		menu			: config.menuColor,
		
		textActive		: colors.lightness( config.textColor,		direction * 0.1 ),
		menuDark		: colors.lightness( config.menuColor,		direction * -0.2 ),
		menuLight		: colors.lightness( config.menuColor,		direction * 0.2 ),
		
		primary			: colors.mix( config.primaryColor, config.menuColor, 0.2 ),
		level			: colors.mix( config.primaryColor, config.menuColor, 0.9 ),
		levelActive		: colors.mix( config.primaryColor, config.menuColor, 0.6 )
		
	}, colors.hexToString ));
	
	insertCss( css );
	
};

var runHtmlTemplates = function( manifestKeyValuePairs, config ) {
		
	var levels = Reduce( manifestKeyValuePairs, function( memo, keyPair ) {
		return memo + _levelTemplate({
			slug: keyPair[0],
			manifest: keyPair[1]
		})
	}, "");
	
	var html = _menuTemplate({
		levels : levels
	});
		
	//Attach elements
	var div = document.createElement('div');
	div.innerHTML = html;
	
	function appendOrSetInnerHtml( el, contents ) {
		if( IsElement( contents ) ) {
			el.appendChild( contents );
		} else {
			el.innerHTML = contents;
		}
	}
	
	appendOrSetInnerHtml( div.getElementsByClassName('poem-menu-top')[0],				config.top );
	appendOrSetInnerHtml( div.getElementsByClassName('poem-menu-levels-top')[0],		config.beforeLevels );
	appendOrSetInnerHtml( div.getElementsByClassName('poem-menu-levels-bottom')[0],		config.afterLevels );
	appendOrSetInnerHtml( div.getElementsByClassName('poem-menu-bottom')[0],			config.bottom );
	
	document.body.insertBefore( div, document.body.firstChild );
	
	return div;
};

module.exports = function menu( manifests, properties ) {

	loadTemplatesOnce();

	var config = Extend({
		hamburgerColor				: 0xffffff,
		primaryColor				: 0x54AFFF,
		textColor					: 0x9FC6E1,
		menuColor					: 0x272E34,
		top							: "Poem",
		beforeLevels				: "",
		afterLevels					: "",
		bottom						: "",
		preventDefaultLevelLinks	: true,
		toggleKey					: 27 //escape
	}, properties);
	
    var emitter = new EventEmitter();
	var manifestKeyValuePairs = sortAndFilterManifests( manifests )
	
	runCssTemplates( config );
	var div = runHtmlTemplates( manifestKeyValuePairs, config );
    var commands = handlers( config, emitter, div );
	
	return {
		emitter : emitter,
		close : commands.close,
		open : commands.open
	};
	
};